import { DialogTitle } from "@radix-ui/react-dialog";
import { DialogHeader } from "../../utils/components/ui/dialog";
import { Button } from "../../utils/components/ui/button";
import { ErrorWraper } from "../common/ErrorWrapper";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { ReusableCombobox } from "../../utils/components/ui/combobox";
import { useGetAllInvoice } from "../../service/invoiseService";

interface Props {
  setOpen: (open: boolean) => void;
  onContinue?: (invoiceNumber: string) => void;
}

function AddNewSalesReturn({ setOpen, onContinue }: Props) {
  const navigate = useNavigate();
  const [selectedInvoice, setSelectedInvoice] = useState("");
  const [comboboxOpen, setComboboxOpen] = useState(false);
  const [searchKey, setSearchKey] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm<{ invoiceNumber: string }>({
    defaultValues: {
      invoiceNumber: "",
    },
  });

  // Fetch sales invoice numbers for dropdown using useGetAllInvoice
  const { data } = useGetAllInvoice({
    pageNo: 0,
    pageSize: 10,
    invoiceNumber: searchKey,
  });

  const invoiceOptions =
    data?.invoiceResponse?.map((item: any) => ({
      value: String(item.id),
      label: item.invoiceNumber,
    })) || [];

  const handleCancel = () => {
    setOpen(false);
    reset();
    setSelectedInvoice("");
  };

  const handleContinue = (data: { invoiceNumber: string }) => {
    if (onContinue) onContinue(data.invoiceNumber);
    navigate(`/sales-return/${data.invoiceNumber}`);
    setOpen(false);
    reset();
    setSelectedInvoice("");
  };

  return (
    <div className="space-y-4">
      <DialogHeader>
        <DialogTitle className="text-[#1A5EF9] text-xl font-medium">
          Sales Return
        </DialogTitle>
      </DialogHeader>
      <form onSubmit={handleSubmit(handleContinue)} className="space-y-4">
        <div>
          <label className="text-[#1A5EF9] text-sm mb-1 block">
            Enter Invoice Number
          </label>
          <ErrorWraper message={errors.invoiceNumber?.message}>
            {/* Hidden input for form validation */}
            <input
              type="hidden"
              {...register("invoiceNumber", {
                required: "Invoice number is required",
              })}
            />
            <ReusableCombobox
              options={invoiceOptions}
              value={selectedInvoice}
              onValueChange={(value) => {
                setSelectedInvoice(value as string);
                setValue("invoiceNumber", value as string);
                setComboboxOpen(false);
              }}
              open={comboboxOpen}
              setOpen={setComboboxOpen}
              placeholder="Invoice Number"
              searchPlaceholder="Search invoice..."
              emptyText="No invoices found."
              className="w-full bg-[#F3F4F3] rounded border border-[#BAC4C0] h-10"
              onInputChange={(val) => setSearchKey(val)}
            />
          </ErrorWraper>
        </div>
        <div className="flex justify-end gap-3 pt-4">
          <Button
            type="button"
            variant="outline"
            className="border-[#BAC4C0] text-[#84928C] hover:bg-gray-50 px-6 py-2"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            className="bg-[#1A5EF9] hover:bg-[#1450D1] text-white px-6 py-2"
          >
            Continue
          </Button>
        </div>
      </form>
    </div>
  );
}

export default AddNewSalesReturn;
